import { Component, OnInit, Input, HostListener, DoCheck, ElementRef, Renderer2 } from '@angular/core';
import { Cell, TableHandler } from '../../../../../../../classes';

@Component({
  selector: '[regular-cell]',
  templateUrl: './regular-cell.component.html',
  styleUrls: ['./regular-cell.component.scss']
})
export class RegularCellComponent implements OnInit, DoCheck {
  @Input() table:TableHandler;
  @Input() cell:Cell;
  
  constructor(
    private elementRef:ElementRef,
    private renderer:Renderer2,
  ) { }

  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'position-relative');
    // this.renderer.addClass(this.elementRef.nativeElement, 'noselect');
    // this.renderer.addClass(this.elementRef.nativeElement, 'p-0');
  }
  ngDoCheck () {
    if (
      (this.table.focus.colId === this.cell.colId && this.table.focus.rowId === undefined) 
      || (this.table.focus.colId === undefined && this.table.focus.rowId === this.cell.rowId) 
      || (this.table.focus.colId === this.cell.colId && this.table.focus.rowId === this.cell.rowId)
    ) {
      this.renderer.addClass(this.elementRef.nativeElement, 'focus');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'focus');
    }

    if (this.cell.quota === 0) {
      this.renderer.addClass(this.elementRef.nativeElement, 'disabled');      
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'disabled');      
    }
  }
  @HostListener('click', []) toggleFocus (bool:boolean = undefined) {
    this.table.toggleFocus(this.cell.colId, this.cell.rowId, bool);
    this.toggleQuota();
  }
  toggleQuota () {
    if (this.cell.canHaveQuota ) this.cell.quota = this.cell.quota === 1 ? 0 : 1;
    else this.cell.quota = this.cell.quota === undefined ? 0 : undefined;
  }

}
